module.exports = __webpack_public_path__ + "static/media/resume.ba281a70.svg";